/* eslint-disable camelcase */

export const constants = {
  POST_SERVICE_PRODUCT_ORDER: 'POST_SERVICE_PRODUCT_ORDER',
  POST_SERVICE_PRODUCT_ORDER_SUCCESS: 'POST_SERVICE_PRODUCT_ORDER_SUCCESS',
  POST_SERVICE_PRODUCT_ORDER_FAIL: 'POST_SERVICE_PRODUCT_ORDER_FAIL',
  PUT_SERVICE_PRODUCT_ORDER: 'PUT_SERVICE_PRODUCT_ORDER',
  PUT_SERVICE_PRODUCT_ORDER_SUCCESS: 'PUT_SERVICE_PRODUCT_ORDER_SUCCESS',
  PUT_SERVICE_PRODUCT_ORDER_FAIL: 'PUT_SERVICE_PRODUCT_ORDER_FAIL',
  RESET_SERVICE_PRODUCT_ORDER: 'RESET_SERVICE_PRODUCT_ORDER',
  GET_SERVICE_PRODUCT_ORDER_FROM_SOCKETS: 'GET_SERVICE_PRODUCT_ORDER_FROM_SOCKETS',
};

export const services = {
  postServiceProductOrder: (data) => ({
    route: `/api/v2/lines/${data.lineId}/services/${data.serviceSlug}/order/${data.serviceProductUuid}`,
    method: 'post',
    body: data,
  }),

  putServiceProductOrder: (data) => ({
     route: `/api/v2/lines/${data.lineId}/services/${data.serviceSlug}/order/${data.serviceProductUuid}/${data.serviceProductOrderUuid}`,
    method: 'put',
    body: data,
  }),
};
